import { render, staticRenderFns } from "./CardTarjaCronometro.vue?vue&type=template&id=3f4a6a5c&scoped=true"
import script from "./CardTarjaCronometro.vue?vue&type=script&lang=js"
export * from "./CardTarjaCronometro.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaCronometro.vue?vue&type=style&index=0&id=3f4a6a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a6a5c",
  null
  
)

export default component.exports